// extracted by mini-css-extract-plugin
module.exports = {"container":"stopwatch_container__3k84L"};